// Authentication
export const SET_PROFILE = 'SET_PROFILE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const START_LOGIN = 'START_LOGIN'
export const LOGOUT = 'LOGOUT'

// queries basket
export const BASKET_ADD = 'BASKET_ADD'
export const BASKET_REMOVE = 'BASKET_REMOVE'
export const BASKET_CLEAR = 'BASKET_CLEAR'
export const BASKET_START = 'BASKET_START'
export const BASKET_FAIL = 'BASKET_FAIL'
export const BASKET_SUCCESS = 'BASKET_SUCCESS'
export const SET_TABLES = 'SET_TABLES'
export const SET_TABLE_VERSIONS = 'SET_TABLE_VERSIONS'
export const START_EDITING_TABLE = 'START_EDITING_TABLE'
export const DONE_EDITING_TABLE = 'DONE_EDITING_TABLE'

export const SET_START_DATE = 'SET_START_DATE'
export const SET_END_DATE = 'SET_END_DATE'

export const SET_POST_RESAMPLE = 'SET_POST_RESAMPLE'
export const SET_PRE_RESAMPLE = 'SET_PRE_RESAMPLE'
export const SET_AGGREGATION_METHOD = 'SET_AGGREGATION_METHOD'

// rules management
export const CLEAR_RULES = 'CLEAR_RULES'
export const CLEAR_ROLES = 'CLEAR_ROLES'
export const GET_RULES = 'GET_RULES'
export const GET_ROLES = 'GET_ROLES'
export const ADD_RULE = 'ADD_RULE'
export const DROP_RULE = 'DROP_RULE'
export const RULE_ERROR = 'RULE_ERROR'
